import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import Style from "./css/style.module.css";
import SelectPointArea from "./area/select_point";

function ChargePointPopupArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const [corp_info, set_corp_info] = useState<any>({
    a_response_tel: "",
  });
  const [charge_data, set_charge_data] = useState({
    "point": 0,
  });

  useEffect(() => {
    get_corp_info_by_ajax();
  }, [user.comp_seq]);

  const get_corp_info_by_ajax = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    if (strFunc.is_empty(user.corp_seq)) {
      return false;
    }
    let formJsonData = {
      "s_seq": [user.corp_seq],
      "s_addon_logo_img": "1",
      "s_addon_opt_data": "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/corp/corp/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_corp_info(response.data["data"]["info_arr"][0]);
          }
        }
      });
  };

  const go_charge_point_payt_by_ajax = () => {
    if (strFunc.is_empty(charge_data.point)) {
      return false;
    }
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    if (strFunc.is_empty(corp_info.a_response_tel)) {
      alert("학원정보에서 학원핸드폰을 먼저 등록해 주세요.");
      return false;
    }

    if (confirm("포인트 주문을 하시겠습니까?") == false) {
      return false;
    }

    //point order 등록 후, payt 전송
    let point_order = {
      "a_ymd": DateFunc.get_date_format(new Date(), "Ymd"),
      "a_seq": "",
      a_mcomp_seq: user.comp_seq,
      a_user_seq: user.user_seq,
      a_user_name: user.user_name,
      a_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
      a_title: corp_info.a_company_name + " 포인트 충전",
      a_price: charge_data.point,
      a_price_tax: 0,
      a_price_sum: charge_data.point,
      a_amount: 1,
      a_pay_sort: "",
      a_is_pay: "",
    };
    let form_json_data: any = {
      data_arr: [point_order],
      is_default_val: "1"
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/point_order/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"] && response.data["data"].length > 0) {
            let point_order_info = response.data["data"][0];
            send_point_payt_by_ajax({
              point_order_info: point_order_info
            });
          } else {
            alert("포인트 주문서 생성에 실패했습니다.");
          }
        } else {
          alert("포인트 주문서 생성에 실패했습니다." + response.data["msg"]);
        }
      });
  };

  const send_point_payt_by_ajax = (inData: any) => {
    let opt_obj = {
      point_order_info: null,
      ...inData
    };
    let point_order_info = opt_obj.point_order_info;
    if (strFunc.is_empty(point_order_info)) {
      alert("포인트 주문서 정보가 없습니다.");
      return false;
    }

    let tmp_order_pri_val = point_order_info.a_ymd + "," + point_order_info.a_seq;
    let receiv_phone_json = {
      phone_num: corp_info.a_response_tel,
      receiver: corp_info.a_company_name,
      order_seq: tmp_order_pri_val,
    };

    let form_json_data: any = {
      order_seq_arr: [tmp_order_pri_val],
      receiv_phone_num_arr: [receiv_phone_json]
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/point_order/send_payt', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          get_point_order_and_go_url({
            point_order_info: point_order_info
          });
        } else {
          alert("포인트 결제 요청에 실패했습니다." + response.data["msg"]);
        }
      });
  };

  const get_point_order_and_go_url = (inData: any) => {
    let opt_obj = {
      point_order_info: null,
      ...inData
    };

    let point_order_info = opt_obj.point_order_info;
    if (strFunc.is_empty(point_order_info)) {
      alert("포인트 주문서 정보가 없습니다.");
      return false;
    }

    let tmp_order_pri_val = point_order_info.a_ymd + "," + point_order_info.a_seq;
    let form_json_data: any = {
      s_pri_arr: [tmp_order_pri_val],
      is_paging: "",
      s_addon_payt: "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/point_order/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let point_order_info = response.data["data"]["info_arr"][0];
            if (point_order_info.payt_supply) {
              if (point_order_info.payt_supply["a_state"] == "send") {
                let a_bill_url = point_order_info.payt_supply["a_bill_url"];
                //window.open(a_bill_url);
                alert("포인트 결제 요청이 완료되었습니다. 결제 페이지에서 결제를 진행해 주세요.");
                myProps.closePopup();
                myProps.refreshData({});
              } else {
                alert("포인트 주문서의 결제 상태가 '발송'이 아닙니다.");
              }
            }
          } else {
            alert("포인트 주문서 조회가 없습니다.");
          }
        } else {
          alert("포인트 주문 조회에 실패했습니다." + response.data["msg"]);
        }
      });
  };

  return (
    <div className={Style.popup_container}>

      {/* Point Selection Area */}
      <div className={Style.content}>
        <SelectPointArea
          Style={Style}
          charge_data={charge_data}
          set_charge_data={set_charge_data}
        />
      </div>

      {/* Summary Section */}
      <div className={Style.summary_section}>
        <div className={Style.summary_card}>
          <div className={Style.summary_row}>
            <span className={Style.summary_label}>충전할 포인트</span>
            <span className={Style.summary_value}>
              {charge_data.point > 0 ? (
                <>
                  <span className={Style.point_amount}>{strFunc.comma(charge_data.point)}</span>
                  <span className={Style.point_unit}>P</span>
                </>
              ) : (
                <span className={Style.point_placeholder}>포인트를 선택하세요</span>
              )}
            </span>
          </div>
          {charge_data.point > 0 && (
            <div className={Style.summary_info}>
              결제 금액: {strFunc.comma(charge_data.point)}원
            </div>
          )}
        </div>
      </div>

      {/* Action Buttons */}
      <div className={Style.button_group}>
        <button
          className={Style.button_primary}
          disabled={charge_data.point === 0}
          onClick={() => {
            // TODO: 결제 로직 구현
            go_charge_point_payt_by_ajax();
          }}
        >
          <svg className={Style.button_icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          결제하기
        </button>
        <button
          className={Style.button_secondary}
          onClick={() => {
            myProps.closePopup();
          }}
        >
          닫기
        </button>
      </div>
    </div>
  );
};
export default ChargePointPopupArea;